import PropTypes from "prop-types";
import styled from "styled-components";

const StyledOptionListContainer = styled.div`
    height: calc(100vh - 200px);
    overflow-y: auto;
`;

/**
 * Scrollable container for group list items.
 *
 * @param root0 - The component props.
 * @param root0.children - The group list item elements.
 * @returns The rendered group list.
 */
const GroupList = ({ children }) => (
    <StyledOptionListContainer>
        <div className="listGroup">{children}</div>
    </StyledOptionListContainer>
);

GroupList.propTypes = {
    children: PropTypes.node.isRequired,
};

export default GroupList;
